import { getLocalStorageData } from "@picovico/utils";
import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  cinema_hall: null | string;
  isOpen: boolean;
} = {
  cinema_hall: null,
  isOpen: !getLocalStorageData("cinema_hall"),
};

export const cinemaHallSlice = createSlice({
  name: "activeCinemaHall",
  initialState,
  reducers: {
    updateCinemaHall(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateCinemaHall } = cinemaHallSlice.actions;
